import { render, staticRenderFns } from "./OfferCardPlannedChanges.vue?vue&type=template&id=3c6d4604&"
import script from "./OfferCardPlannedChanges.vue?vue&type=script&lang=ts&"
export * from "./OfferCardPlannedChanges.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCardPlannedChanges.vue?vue&type=style&index=0&id=3c6d4604&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports